"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_player_1 = __importDefault(require("react-player"));
var themes_1 = require("../../themes");
var TextInputs_1 = require("../TextInputs");
var Typo_1 = require("../Typo");
var Embed_1 = require("./comps/Embed");
function IFrameInput(_a) {
    var label = _a.label, sublabel = _a.sublabel, value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange, readOnly = _a.readOnly, isRequired = _a.isRequired, errorMsgs = _a.errorMsgs, isInRTE = _a.isInRTE, invert = _a.invert;
    var _b = (0, react_1.useState)(true), isValidURL = _b[0], setIsValidURL = _b[1];
    var createEmbedPreview = function () {
        switch (true) {
            case !value:
                return (react_1.default.createElement(Typo_1.SANS_0, { bold: true, invert: true }, "paste a value above to view preview of Google Slide"));
            case react_player_1.default.canPlay(value): // We don't want to show video if it is valid video url
                return (react_1.default.createElement(Typo_1.SANS_0, { color: themes_1.colors.red }, "Video Links are not allowed"));
            default:
                return react_1.default.createElement(Embed_1.Embed, __assign({}, readOnly, { value: value, isValidURL: isValidURL, onChange: onChange }));
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null, readOnly ?
        react_1.default.createElement(Embed_1.Embed, __assign({}, readOnly, { value: value, isValidURL: isValidURL, onChange: onChange, isBlock: true }))
        :
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(TextInputs_1.URLInput, { placeholder: placeholder || 'Enter a valid embedable url', onChange: function (k, v) { return onChange(k, v); }, value: value, isRequired: isRequired, label: label, S: true, invert: invert, readOnly: readOnly, sublabel: sublabel, passValidationErrorToFormValidation: function (type) { return type === "error" ? setIsValidURL(false) : setIsValidURL(true); }, icon: "LinkSimple", clearBtn: !isInRTE && { text: "Clear", onClick: function () { return onChange(undefined); }, invert: invert } }),
                createEmbedPreview())));
}
exports.default = IFrameInput;
